interface BreadCrumbProps {
    title: string
    subTitle?: string
}

export function BreadCrumb({title, subTitle}: BreadCrumbProps) {
    return (
        <div className="level mb0">
            <div className="level-left" style={{height: 64}}>
                <h5 className="is-size-5 has-text-weight-bold ml5">{title}</h5>
                {subTitle && (
                    <span className="ml10 gray-label">{subTitle}</span>
                )}
            </div>
            <div className="level-right">

            </div>
        </div>
    )
}